import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-turns-reports',
  templateUrl: './turns-reports.component.html',
  styleUrls: ['./turns-reports.component.scss']
})
export class TurnsReportsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
